<template>
  <div>
    <h1>Token Dashboard</h1>
    <p v-if="walletAddress">Wallet Address: {{ walletAddress }}</p>
    <p v-if="tokenMint">Token Mint: {{ tokenMint }}</p>
    <p v-if="tokenBalance !== null">Token Balance: {{ tokenBalance }}</p>
    <p v-else>Loading token balance...</p>
    <p v-if="tokenData.name">Token Name: {{ tokenData.name }}</p>
    <p v-if="tokenData.symbol">Token Symbol: {{ tokenData.symbol }}</p>
    <p v-if="tokenData.description">Description: {{ tokenData.description }}</p>
    <p v-if="tokenData.extensions?.website">
      Website:
      <a :href="tokenData.extensions.website" target="_blank">{{
        tokenData.extensions.website
      }}</a>
    </p>
    <div v-if="tokenData.tags && tokenData.tags.length">
      <p>Tags:</p>
      <ul>
        <li v-for="tag in tokenData.tags" :key="tag">{{ tag }}</li>
      </ul>
    </div>
    <div v-if="tokenData.creator">
      <p>Creator: {{ tokenData.creator.name }}</p>
      <p>
        Creator Website:
        <a :href="tokenData.creator.site" target="_blank">{{
          tokenData.creator.site
        }}</a>
      </p>
    </div>
    <div v-if="tokenData.image">
      <p>Token Image:</p>
      <img
        :src="tokenData.image"
        alt="Token Image"
        style="max-width: 300px; margin-top: 10px"
      />
    </div>
    <p v-if="error" class="error-message">{{ error }}</p>
    <!-- Logout Button -->
    <button class="logout-button" @click="logout">Logout</button>
  </div>
</template>

<script>
import { Connection, PublicKey } from "@solana/web3.js";

export default {
  name: "DashboardView",
  data() {
    return {
      walletAddress: null,
      tokenMint: null,
      tokenBalance: null,
      tokenData: {}, // Store fetched JSON data here
      error: null,
    };
  },
  async mounted() {
    try {
      const { walletAddress, tokenMint } = this.$route.query;

      if (!walletAddress || !tokenMint) {
        throw new Error("Missing wallet address or token mint.");
      }

      this.walletAddress = walletAddress;
      this.tokenMint = tokenMint;

      const connection = new Connection(
        "https://mainnet.helius-rpc.com/?api-key=0d6562be-08f2-4659-92bb-54fbcadd00b2"
      );

      // Fetch token accounts and calculate balance
      const accounts = await connection.getParsedTokenAccountsByOwner(
        new PublicKey(this.walletAddress),
        { mint: new PublicKey(this.tokenMint) }
      );

      if (accounts.value.length > 0) {
        const accountInfo = accounts.value[0].account.data.parsed.info;
        this.tokenBalance = accountInfo.tokenAmount.uiAmount;
        console.log("Fetched Token Info:", accountInfo);
      } else {
        this.tokenBalance = 0;
        console.warn("No token accounts found for this mint.");
      }

      // Fetch and display JSON file
      const metadataUrl =
        "https://bafkreigxhz3sz4dwpls6ja2d5qanvtjvxda3765dlycnwhx45zzeuwotkq.ipfs.nftstorage.link";
      const response = await fetch(metadataUrl);
      if (response.ok) {
        this.tokenData = await response.json();
        console.log("Fetched Token Metadata JSON:", this.tokenData);
      } else {
        console.warn("Failed to fetch token metadata JSON:", response);
        this.error = "Failed to fetch token metadata.";
      }
    } catch (err) {
      console.error("Error fetching token information:", err);
      this.error = "Failed to load token information. Please try again.";
    }
  },
  methods: {
    async logout() {
      if (window.solana && window.solana.isPhantom) {
        try {
          await window.solana.disconnect(); // Disconnect the wallet
          this.walletAddress = null;
          this.tokenMint = null;
          this.tokenBalance = null;
          this.tokenData = {};
          console.log("Wallet disconnected successfully.");
        } catch (err) {
          console.error("Error disconnecting wallet:", err);
        }
      }

      // Redirect to home page
      this.$router.push({ name: "HomeView" });
    },
  },
};
</script>

<style>
h1 {
  margin-bottom: 20px;
}
p {
  font-size: 18px;
  margin-bottom: 10px;
}
a {
  color: blue;
  text-decoration: underline;
}
ul {
  margin-top: 0;
  margin-bottom: 10px;
}
.error-message {
  color: red;
  margin-top: 20px;
}
img {
  display: block;
  max-width: 100%;
  height: auto;
}
.logout-button {
  margin-top: 20px;
  padding: 10px 20px;
  font-size: 16px;
  color: white;
  background-color: red;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}
.logout-button:hover {
  background-color: darkred;
}
</style>
